import { render, staticRenderFns } from "./shopDetailShop.vue?vue&type=template&id=0b300bc3&scoped=true"
import script from "./shopDetailShop.vue?vue&type=script&lang=js"
export * from "./shopDetailShop.vue?vue&type=script&lang=js"
import style0 from "./shopDetailShop.vue?vue&type=style&index=0&id=0b300bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b300bc3",
  null
  
)

export default component.exports